export const getIsSafari = (): boolean => {
	return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

export const supportsTouch = (): boolean => {
	if (typeof window === 'undefined' || typeof navigator === 'undefined') {
		return false;
	}

	return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

export const shouldUseCanvasRenderer = (): boolean => {
	if (typeof navigator === 'undefined') {
		return false;
	}

	// Mobile WebViews can terminate during WebGL allocation or teardown, leaving the host app white.
	const isIpadWithDesktopUserAgent = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

	return /Android|iPad|iPhone|iPod/i.test(navigator.userAgent) || isIpadWithDesktopUserAgent;
};
